import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/client/createClient.module.scss";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { coachRoutes } from "../../routers/CoachRouters";
import Swal from "sweetalert2";
import Close_Button from "../../assets/auth/close.png";
import sucess from "../../assets/exercise/success.png";
import { dispatch, toggle } from "../../redux";
import { createClientService } from "../../services";

const CreateClientAccount = () => {
  const { isLoading } = useSelector((state) => state.coach);
  const isSidebarOpen = useSelector((state) => state.navbar.button);

  const navigate = useNavigate();
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };

  // Form state for client creation
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    phone: "",
    email: "",
    gender: "",
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Client name is required";
    }

    if (!formData.dob) {
      newErrors.dob = "Date of birth is required";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone.replace(/\D/g, ""))) {
      newErrors.phone = "Please enter a valid 10-digit phone number";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.gender) {
      newErrors.gender = "Gender is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Helper function to format date
  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() returns 0-11
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  // Modified handleCreate function
  const handleCreate = async () => {
    if (!validateForm()) {
      return;
    }

    // Format the data before sending
    const formattedData = {
      ...formData,
      dob: formatDateToDDMMYYYY(formData.dob),
    };

    console.log("Creating client:", formattedData);

    try {
      // Send the formatted data to the service
      const success = await createClientService(formattedData);

      if (success) {
        Swal.fire({
          html: `
          <div style="text-align: center; border-radius: 20px; position: relative; font-family: 'gothambold', sans-serif;">
            <button 
              id="customCloseButton" 
              style="position: absolute; top: -10px; right: -20px; background: none; border: none; cursor: pointer;">
              <img 
                src=${Close_Button} 
                alt="Close" 
                style="width: 50px; height: 50px;"
              />
            </button>
            <img 
              src=${sucess} 
              alt="Success" 
              style="width: 100px; margin-bottom: 20px; margin-top: 30px;" 
            />
            <h2 style="margin: 0; font-family: 'gothambold', sans-serif;">Client Created!</h2>
            <br/>
            <p style="font-family: 'Gotham Book', sans-serif;">
              You've successfully created a new client account.Password is sent to the registered email: <strong>${formData.email}</strong>

            </p>
            <br/>
            <button 
              id="okButton" 
              style="
                background: linear-gradient(0deg, #151515 0%, #525252 100%); 
                color: #f3f3f6; 
                padding: 10px 30px; 
                border: none; 
                border-radius: 5px; 
                cursor: pointer; 
                margin-top: 20px; 
                font-family: 'gothambold', sans-serif;
              ">
             Close
            </button>
          </div>
        `,
          showConfirmButton: false,
          customClass: {
            popup: "custom-swal-container",
          },
          didOpen: () => {
            const okButton = document.getElementById("okButton");
            okButton.addEventListener("click", () => {
              Swal.close();
              navigate(coachRoutes.listClient);
              // Reset form after successful creation
              setFormData({
                name: "",
                dob: "",
                phone: "",
                email: "",
                gender: "",
              });
            });
          },
        });
      }
    } catch (error) {
      console.error("Error creating client:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to create client account. Please try again.",
        icon: "error",
        confirmButtonColor: "#f79328",
      });
    }
  };

  const handleCancel = () => {
    navigate(coachRoutes.dashboard);
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.exercise_list_container_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={coachRoutes.listClient}>HOME / </Link>
          <span>CREATE CLIENT ACCOUNT</span>
        </h2>
        <div className={Styles.exercise_list_container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <h3>CREATE CLIENT ACCOUNT</h3>
            </div>
          </div>
          <div className={Styles.borderbottomline}></div>

          <div className={Styles.renderedcontentmaindiv}>
            {isLoading ? (
              <div className={Styles.loading_container}>
                <p>Loading...</p>
              </div>
            ) : (
              <div className={Styles.profile_form}>
                <div className={Styles.form_grid}>
                  <div className={Styles.form_field}>
                    <label className={Styles.field_label}>Client Name</label>
                    <input
                      type="text"
                      className={`${Styles.form_input} ${
                        errors.name ? Styles.error : ""
                      }`}
                      value={formData.name}
                      onChange={(e) =>
                        handleInputChange("name", e.target.value)
                      }
                      placeholder="Enter here"
                    />
                    {errors.name && (
                      <span className={Styles.error_message}>
                        {errors.name}
                      </span>
                    )}
                  </div>

                  <div className={Styles.form_field}>
                    <label className={Styles.field_label}>DOB</label>
                    <input
                      type="date"
                      className={`${Styles.form_input} ${Styles.date_input} ${
                        errors.dob ? Styles.error : ""
                      }`}
                      value={formData.dob}
                      onChange={(e) => handleInputChange("dob", e.target.value)}
                      max={new Date().toISOString().split("T")[0]}
                    />
                    {errors.dob && (
                      <span className={Styles.error_message}>{errors.dob}</span>
                    )}
                  </div>

                  <div className={Styles.three_column_row}>
                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>Phone Number</label>
                      <input
                        type="tel"
                        className={`${Styles.form_input} ${
                          errors.phone ? Styles.error : ""
                        }`}
                        value={formData.phone}
                        onChange={(e) => {
                          const numericValue = e.target.value
                            .replace(/[^0-9]/g, "")
                            .slice(0, 10);
                          handleInputChange("phone", numericValue);
                        }}
                        onKeyPress={(e) => {
                          if (
                            !/[0-9]/.test(e.key) &&
                            ![
                              "Backspace",
                              "Delete",
                              "Tab",
                              "Escape",
                              "Enter",
                            ].includes(e.key)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter here"
                      />
                      {errors.phone && (
                        <span className={Styles.error_message}>
                          {errors.phone}
                        </span>
                      )}
                    </div>

                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>Email ID</label>
                      <input
                        type="email"
                        className={`${Styles.form_input} ${
                          errors.email ? Styles.error : ""
                        }`}
                        value={formData.email}
                        onChange={(e) =>
                          handleInputChange("email", e.target.value)
                        }
                        placeholder="Enter here"
                      />
                      {errors.email && (
                        <span className={Styles.error_message}>
                          {errors.email}
                        </span>
                      )}
                    </div>

                    <div className={Styles.form_field}>
                      <label className={Styles.field_label}>Gender</label>
                      <select
                        className={`${Styles.form_input} ${
                          Styles.dropdown_select
                        } ${errors.gender ? Styles.error : ""}`}
                        value={formData.gender}
                        onChange={(e) =>
                          handleInputChange("gender", e.target.value)
                        }
                      >
                        <option value="" disabled>
                          Select Gender
                        </option>
                        <option value="MALE">Male</option>
                        <option value="FEMALE">Female</option>
                      </select>
                      {errors.gender && (
                        <span className={Styles.error_message}>
                          {errors.gender}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className={Styles.borderbottomline}></div>

                <div className={Styles.button_group}>
                  <button className={Styles.save_button} onClick={handleCreate}>
                    Create
                  </button>
                  <button
                    className={Styles.cancel_button}
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateClientAccount;
